module.exports = {
  StarBarcodeEncode: require('./Sample/js/StarBarcodeEncoder'),
  StarWebPrintBuilder: require('./Sample/js/StarWebPrintBuilder'),
  StarWebPrintDisplayBuilder: require('./Sample/js/StarWebPrintDisplayBuilder'),
  StarWebPrintExtManager: require('./Sample/js/StarWebPrintExtManager'),
  StarWebPrintTrader: require('./Sample/js/StarWebPrintTrader'),
}
